<template>
  <section class="w-full overflow-x-hidden overflow-y-auto !rounded-xl heightClass">
    <div
      class="flex items-center gap-2 w-full !box-border justify-between bg-container-background top-0 py-2 px-3 border-b border-page-border sticky z-[1]"
    >
      <div class="flex items-center gap-2">
        <el-button
          @click="goBack"
          size="mini"
          class="bg-transparent !border border-black/20 hover:!border-brand-300 active:!border-brand-500 !py-[6px] !px-2 !rounded-sm hover:!bg-gray-100"
        >
          <span>
            <img src="@/assets/img/icons/new/left-back-icon.svg" alt="" class="!size-3" />
          </span>
        </el-button>

        <div class="text-base">Ask your question</div>
      </div>
      <div class="flex items-center gap-2">
        <el-button
          class="!px-3 !py-2 !leading-3 !border !border-[#0000001F] !rounded-sm !font-normal text-xs 2xl:text-smd hover:!bg-brand-100 hover:!text-brand-500 hover:!border-brand-500"
          @click="goBack"
        >
          Cancel
        </el-button>
        <button
          @click="createNewQuestion"
          class="!px-3 !py-1 text-white !bg-brand-500 !rounded-sm text-xs 2xl:text-smd"
        >
          Post Your Question
        </button>
      </div>
    </div>
    <div class="!px-6">
      <!-- Form Wrapper -->
      <div class="form-wrapper grid grid-cols-1 lg:!grid-cols-2 gap-6">
        <div>
          <!-- Question Type -->
          <div class="form-group">
            <div class="form-label-with-required">
              <label>Select Type</label>
              <span class="required">*</span>
            </div>
            <el-radio-group v-model="form.type">
              <el-radio label="topic">Specific Topic</el-radio>
              <el-radio label="general">General</el-radio>
            </el-radio-group>
          </div>

          <!-- Topic-specific Section -->
          <div v-if="form.type === 'topic'">
            <!-- Entity Selection -->
            <div class="form-group">
              <div class="form-label-with-required">
                <label>Category</label>
                <span class="required">*</span>
              </div>
              <el-select
                v-model="form.entity_id"
                placeholder="Select Category"
                @change="selectEntity"
                filterable
              >
                <el-option
                  v-for="entity in allEntities"
                  :key="entity._id"
                  :value="entity._id"
                  :label="entity.name"
                />
              </el-select>
            </div>

            <!-- Entity Data -->
            <div class="form-group">
              <div class="form-label-with-required">
                <label>Item</label>
                <span class="required">*</span>
              </div>
              <el-select v-model="form.entity_data_id" placeholder="Select Item" filterable>
                <el-option
                  v-for="data in allEntitiesData"
                  :key="data._id"
                  :value="data._id"
                  :label="getLabel(data)"
                />
              </el-select>
            </div>
          </div>

          <!-- Title -->
          <div class="form-group">
            <div class="form-label-with-required">
              <label>Title</label>
              <span class="required">*</span>
            </div>
            <el-input v-model="form.title" />
          </div>
          <!-- Share With (General Type) -->
          <div class="form-group share-form">
            <div class="form-header">
              <label>Share with</label>
              <span class="required">*</span>
            </div>
            <label>Company Users:</label>
            <el-select multiple collapse-tags filterable v-model="form.user_types">
              <el-option label="All" value="ALL"></el-option>
              <el-option
                v-for="item in userTypesList"
                :key="item._id"
                :label="getUserTypeLabel(item)"
                :value="item._id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div>
          <!-- Content -->
          <div class="form-group">
            <div class="form-label-with-required">
              <label>Content</label>
              <span class="required">*</span>
            </div>
            <CkEditorOffline v-model="form.content" :config="editorConfig"></CkEditorOffline>
          </div>

          <!-- Tags -->
          <div class="form-group">
            <div class="form-label-with-required">
              <label>Tags (use # to prefix)</label>
            </div>
            <el-select
              v-model="form.tags"
              multiple
              filterable
              allow-create
              default-first-option
              @change="validateTags"
            >
              <el-option v-for="tag in form.tags" :key="tag" :label="tag" :value="tag" />
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { ckEditorConfig } from '@/assets/data/ckeditor_config.ts';
  import { fetchEntitiesByPagination } from '@/repo/entityRepo';
  import { postAPICall } from '../../helpers/httpHelper';
  import FieldsFormatHelper from '../../mixins/FieldsFormatHelper';
  import { mapGetters } from 'vuex';
  import { fetchAllEntityFiltersByEntity } from '@/repo/filtersRepo';
  import { fetchEntityRelationships } from '@/repo/entityRelationshipsRepo';
  import { fetchUserTypes } from '@/repo/commonApiRepo';

  export default {
    mixins: [FieldsFormatHelper],
    data() {
      return {
        form: {
          type: 'topic',
          entity_id: '',
          entity_data_id: '',
          title: '',
          content: '',
          tags: [],
          share_with: [
            {
              entity: '',
              filter: '',
            },
          ],
          user_types: ['ALL'],
        },
        editorConfig: ckEditorConfig,
        allEntities: [],
        allEntitiesData: [],
        getAllEntities: [],
        page: 1,
        hasMore: false,
        entityFiltersMapping: {},
        relationshipEntities: [],
        userTypesList: [],
      };
    },
    components: {
      CkEditorOffline: () => import('@/components/CkEditor.vue'),
    },
    computed: {
      ...mapGetters('auth', ['getActiveContactType']),
      ...mapGetters('applicationUsersPermission', ['getEntityPermission']),
      ...mapGetters('menuManagementV2', ['getEntityMenu']),
      isApplicationUser() {
        return this.$route.name == 'ApplicationUserCreateForum' ? true : false;
      },
      fetchIndividualEntities() {
        return this.getAllEntities.filter((en) => en.entity_type == 'INDIVIDUAL');
      },
      getUserTypeLabel() {
        return (userType) => {
          if (userType && userType.role) {
            return userType.role.title + ' - ' + userType.name;
          } else {
            return userType.name;
          }
        };
      },
    },
    async mounted() {
      await this.getNecessaryInfo();
    },
    methods: {
      disableUser(i, e_id) {
        return this.form.share_with.filter((u, ix) => ix != i && u.entity == e_id).length
          ? true
          : false;
      },
      addShareWith() {
        this.form.share_with.push({
          entity: '',
          filter: '',
        });
      },
      removeShareWith(index) {
        this.form.share_with.splice(index, 1);
      },
      getLabel(data) {
        let entityId = this.form.entity_id.includes('@')
          ? this.form.entity_id.split('@')[0]
          : this.form.entity_id;
        let selectedEntity = this.getAllEntities.find((en) => en._id == entityId);
        let formattedData = selectedEntity.primaryFields.map((pf) => {
          return this.getFormattedFieldData(
            {
              pf,
              key: pf.key.includes('#') ? pf.key : pf.template_id + '#' + pf.key,
            },
            data.templates_fields_data,
            true
          );
        });
        return formattedData.join(' - ');
      },
      validateTags() {
        let allValid = this.form.tags.every((tag) => tag.startsWith('#'));
        if (!allValid) {
          this.form.tags = this.form.tags.filter((tag) => tag.startsWith('#'));
          this.$message.error('Tag must start with #');
        }
      },
      async getNecessaryInfo() {
        if (this.$route.query.entity_id) {
          this.form.entity_id = this.$route.query.entity_id;
        }
        if (this.$route.query.entity_data_id) {
          this.form.entity_data_id = this.$route.query.entity_data_id;
        }
        let response;
        [response, this.userTypesList] = await Promise.all([
          fetchEntitiesByPagination({
            get_all: true,
          }),
          fetchUserTypes(),
        ]);
        this.getAllEntities = response.data || [];
        await Promise.all(
          this.getAllEntities.map(async (en) => {
            if (en.entity_type == 'INDIVIDUAL') {
              this.entityFiltersMapping[en._id] = await fetchAllEntityFiltersByEntity({
                entityId: en._id,
              });
            }
          })
        );
        if (this.isApplicationUser) {
          if (this.$route.query.menu_id) {
            let id = this.$route.query.menu_id;
            let menu;
            (this.getEntityMenu?.menu_list || [])?.forEach((e) => {
              if (e._id == id) {
                menu = e;
              } else if (e.children) {
                (e.children || []).forEach((el) => {
                  if (el._id == id) {
                    menu = el;
                  } else if (el.children) {
                    (el.children || []).forEach((ele) => {
                      if (ele._id == id) {
                        menu = ele;
                      }
                    });
                  }
                });
              }
            });
            if (menu.forum_entities) {
              menu.forum_entities.map((en) => {
                let entityId = en.includes('@') ? en.split('@')[0] : en;
                this.allEntities.push({
                  _id: en,
                  name:
                    (en.includes('@') && en.split('@')[1] == 'RELATIONSHIP' ? 'My ' : '') +
                    this.getAllEntities.find((e) => e._id == entityId)?.name,
                });
              });
            }
          } else {
            (Object.keys(this.getEntityPermission?.other_entities || {}) || []).map((en) => {
              let entity = this.getAllEntities.find((e) => e._id == en);
              if (entity) {
                this.allEntities.push({
                  _id: en,
                  name: entity?.name,
                });
              }
            });
            (Object.keys(this.getEntityPermission?.relational_entities || {}) || []).map((en) => {
              let entity = this.getAllEntities.find((e) => e._id == en);
              if (entity) {
                this.allEntities.push({
                  _id: en + '@RELATIONSHIP',
                  name: 'My ' + entity?.name,
                });
              }
            });
          }
        } else {
          this.allEntities = response.data || [];
        }
        if (this.form.entity_id && !this.allEntities.find((en) => en._id == this.form.entity_id)) {
          this.form.entity_id = '';
        }
        if (this.form.entity_data_id) {
          this.selectEntity();
        }
      },
      async selectEntity() {
        this.allEntitiesData = [];
        if (this.form.entity_id) {
          let entityId = this.form.entity_id.includes('@')
            ? this.form.entity_id.split('@')[0]
            : this.form.entity_id;
          let isRelation =
            this.form.entity_id.includes('@') &&
            this.form.entity_id.split('@')[1] == 'RELATIONSHIP';
          let selectedEntity = this.getAllEntities.find((entity) => entity._id == entityId);
          let relationships = await fetchEntityRelationships({
            entity_id: entityId,
            include_type: true,
          });
          this.relationshipEntities = relationships
            .map((rel) =>
              rel?.parent_entity_id?._id == entityId ? rel.child_entity_id : rel.parent_entity_id
            )
            .filter((en) => en?.entity_type == 'INDIVIDUAL');
          if (this.relationshipEntities.length) {
            this.form.share_with = this.relationshipEntities.map((dt) => {
              return {
                entity: dt._id,
                filter: '',
              };
            });
          } else {
            this.form.share_with = [
              {
                entity: '',
                filter: '',
              },
            ];
          }
          let filters = isRelation
            ? [
                {
                  field: 'self#related_to/1',
                  operator: '=',
                  value: this.getActiveContactType.account_data_id,
                  value_type: '',
                  value_source: '',
                  query_type: 'AND',
                  value_field: '',
                  validations: {
                    data_type: '',
                  },
                  nested_related_id: '',
                  data_source: 'self_field',
                  relation_entity_id: this.getActiveContactType.contact_type._id,
                  data_type: 'RELATION',
                },
              ]
            : [];
          let response = await postAPICall('POST', '/entities-data/entity/data/v2', {
            entity_id: selectedEntity._id,
            page: 1,
            limit: 1000,
            template_fields_data: this.prepareTemplateFieldsData(selectedEntity),
            filters,
          });
          if (response?.data?.data?.length) {
            this.allEntitiesData = response.data.data;
          }
          if (
            this.form.entity_data_id &&
            !this.allEntitiesData.find((eData) => eData._id == this.form.entity_data_id)
          ) {
            this.form.entity_data_id = '';
          }
        }
      },
      prepareTemplateFieldsData(entity) {
        return entity.templates.map((temp) => {
          let allFields = entity.primaryFields.filter((pf) => pf.template_id == temp.template_id);
          let fields = allFields.map((pf) =>
            pf.key.includes('#') ? pf.key.split('#')[1] : pf.key
          );
          let extraFields = allFields.map((fd) => {
            switch (fd.inputType) {
              case 'ENTITY':
                return (fd.key.includes('#') ? fd.key.split('#')[1] : fd.key) + '/name';
            }
          });
          return {
            template_id: temp.template_id,
            fields: [...fields, ...extraFields],
          };
        });
      },
      async createNewQuestion() {
        if (
          !this.form.title ||
          !this.form.content ||
          !this.form.user_types.length ||
          (this.form.type == 'topic' && (!this.form.entity_id || !this.form.entity_data_id))
        ) {
          this.$notify.error({
            title: 'Error',
            message: 'Please fill all required data',
          });
          return;
        }
        try {
          let response = await postAPICall('POST', '/forums/create-thread', {
            ...this.form,
            entity_id: this.form.entity_id.includes('@')
              ? this.form.entity_id.split('@')[0]
              : this.form.entity_id,
          });
          if (response.data) {
            this.$notify.success({
              title: 'Success',
              message: 'Your question posted successfully',
            });
            let path = this.isApplicationUser ? '/ap/forums' : '/forums';
            this.$router.replace({
              path,
              query: {
                entity_id: this.form.entity_id.includes('@')
                  ? this.form.entity_id.split('@')[0]
                  : this.form.entity_id,
                entity_data_id: this.form.entity_data_id,
              },
            });
            this.$router.push({
              path,
              query: {
                entity_id: this.form.entity_id.includes('@')
                  ? this.form.entity_id.split('@')[0]
                  : this.form.entity_id,
                entity_data_id: this.form.entity_data_id,
              },
            });
          }
        } catch (err) {
          this.$notify.error({
            title: 'Error',
            message: err,
          });
        }
      },
      goBack() {
        this.$router.go(-1);
      },
    },
    watch: {
      'form.user_types': {
        handler(newVal, oldVal) {
          const added = newVal.find((opt) => !oldVal.includes(opt));
          if (added === 'ALL') {
            this.form.user_types = ['ALL'];
            return;
          }
          if (newVal.includes('ALL') && added !== undefined) {
            this.form.user_types = newVal.filter((opt) => opt !== 'ALL');
          }
        },
      },
    },
  };
</script>
<style scoped>
  .heading {
    font-size: 20px;
    font-weight: 600;
    margin-left: 8px;
  }

  .form-wrapper {
    margin-top: 20px;
  }

  .form-group {
    margin-bottom: 20px;
  }

  .form-group label {
    font-weight: 500;
    color: var(--black-500);
  }

  .required {
    color: red;
    font-weight: bold;
    margin-left: 5px;
  }

  .form-label-with-required {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }

  .form-header {
    display: flex;
    align-items: center;
    font-weight: 500;
    margin-bottom: 10px;
  }

  .el-input,
  .el-select {
    width: 100%;
  }

  .form-buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 30px;
  }

  .el-button {
    padding: 10px 18px;
    font-weight: 600;
  }

  .createforumlabel {
    font-weight: 400;
    font-size: 12px;
    display: block;
  }

  label {
    font-weight: 400;
    font-size: 12px;
  }
</style>
